import { Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { H6, Spinner } from '../../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from '../../../Component/Learning/Common/Form/Post';
import { submitUsers } from '../../../Features/Learning/Users/Utils/UserUtils';
import { setField, resetState } from '../../../Features/Learning/Users/addUserSlice';
import Swal from 'sweetalert2';
import {
    handlePhoneKeyDown,
    isPhoneField,
    isValidIndonesianPhoneValue,
    normalizeIndonesianPhoneValue,
} from '../../../Utils/phoneValidation';

const UserPostContain = (props) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.addUser)
    const startUpload = useSelector(state => state.addUser.isLoading);
    const isUpdate = useSelector(state => state.addUser.isUpdate);

    const handleSuccess = () => {
        dispatch(resetState());
        history(`${process.env.PUBLIC_URL}/users/user-list`);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, "data");
        let errorMessage = '';
        if (data.name === '') {
            errorMessage = 'Nama belum diisi.';
        } else if (data.gender === '') {
            errorMessage = 'Jenis Kelamin belum dipilih.';
        } else if (data.email_verified_at === '') {
            errorMessage = 'Verified belum dipilih.';
        } else if (data.phone === '') {
            errorMessage = 'Nomer Telpon belum diisi.';
        } else if (!isValidIndonesianPhoneValue(data.phone)) {
            errorMessage = 'Nomer Telpon harus diawali 08 dan berisi 10-13 digit angka.';
        } else if (data.parent_phone && !isValidIndonesianPhoneValue(data.parent_phone)) {
            errorMessage = 'No Telpon Wali harus diawali 08 dan berisi 10-13 digit angka.';
        } else if (data.email === '') {
            errorMessage = 'Email belum diisi.';
        } else if (data.username === '') {
            errorMessage = 'Username belum diisi.';
        } else if (data.password === '') {
            errorMessage = 'Password belum diisi.';
        }

        if ((data.name === '' || data.gender === '' || data.email_verified_at === '' || data.phone === '' || data.email === '' || data.username === '' || data.password === '') && !isUpdate) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: errorMessage,
            });
        } else {
            dispatch(submitUsers({ ...data, successCallback: handleSuccess }))
        }
    };
    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetState());
        history(`${process.env.PUBLIC_URL}/users/user-list`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        const nextValue = isPhoneField(name) ? normalizeIndonesianPhoneValue(value) : value;
        dispatch(setField({ field: name, value: nextValue }));
    }

    console.log(data, "data");

    // const handleKeyDown = (e) => {
    //     // Hanya izinkan input angka (0-9) dan backspace
    //     const isValidInput = /^[0-9\b]+$/.test(e.key);

    //     if (!isValidInput && e.key !== 'Backspace') {
    //         e.preventDefault();
    //     }
    // };

    return (
        <PostCommon title={props.label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload ? (
                <Col lg="12">
                    <div className="loader-box">
                        <Spinner attrSpinner={{ className: 'loader-30' }} />
                    </div>
                    <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Sedang proses unggah...'}</H6>
                </Col>
            ) : (
                <div>
                    <Form className="row needs-validation">
                        <Col sm="12">
                            <FormGroup className='mb-3'>
                                <Label for="name" style={{ fontWeight: 'bold' }}>Nama :</Label>
                                <Input className="form-control" id="name" type="text" name="name" placeholder="Masukkan nama user..."
                                    value={data.name}
                                    onChange={handleChanges} />
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label style={{ fontWeight: 'bold' }}>Apakah ini akun QC ? (opsional)</Label>
                                <div className="m-checkbox-inline">
                                    <Label for="male">
                                        <Input className="radio_animated" id="male" type="radio" name="is_qc" value="0"
                                            checked={data.is_qc === "0"}
                                            onChange={handleChanges}
                                        />
                                        Tidak
                                    </Label>
                                    <Label for="female">
                                        <Input className="radio_animated" id="female" type="radio" name="is_qc" value="1"
                                            checked={data.is_qc === "13" || data.is_qc === "1"}
                                            onChange={handleChanges}
                                        />
                                        Ya
                                    </Label>
                                </div>
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label style={{ fontWeight: 'bold' }}>Jadikan email verified?</Label>
                                <div className="m-checkbox-inline">
                                    <Label for="verified_false">
                                        <Input className="radio_animated" id="verified_false" type="radio" name="email_verified_at" value="0"
                                            checked={data.email_verified_at === "0"}
                                            onChange={handleChanges}
                                        />
                                        Tidak
                                    </Label>
                                    <Label for="verified_true">
                                        <Input className="radio_animated" id="verified_true" type="radio" name="email_verified_at" value="1"
                                            checked={data.email_verified_at === "1"}
                                            onChange={handleChanges}
                                        />
                                        Ya
                                    </Label>
                                </div>
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label style={{ fontWeight: 'bold' }}>Jenis Kelamin :</Label>
                                <div className="m-checkbox-inline">
                                    <Label for="qc_false">
                                        <Input className="radio_animated" id="qc_false" type="radio" name="gender" value="Male"
                                            checked={data.gender === 'Male'}
                                            onChange={handleChanges}
                                        />
                                        Pria
                                    </Label>
                                    <Label for="qc_true">
                                        <Input className="radio_animated" id="qc_false" type="radio" name="gender" value="Female"
                                            checked={data.gender === 'Female'}
                                            onChange={handleChanges}
                                        />
                                        Wanita
                                    </Label>
                                </div>
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label for="phone" style={{ fontWeight: 'bold' }}>Nomer Telpon :</Label>
                                <Input className="form-control" id="phone" type="tel" name="phone" placeholder="Contoh: 081234567890" required
                                    inputMode="numeric"
                                    autoComplete="tel"
                                    minLength={10}
                                    maxLength={13}
                                    pattern="08[0-9]{8,11}"
                                    onKeyDown={handlePhoneKeyDown}
                                    value={data.phone}
                                    onChange={handleChanges} />
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label for="email" style={{ fontWeight: 'bold' }}>Email :</Label>
                                <Input className="form-control" id="email" type="email" name="email" placeholder="Masukkan email..." required
                                    value={data.email}
                                    onChange={handleChanges} />
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label for="username" style={{ fontWeight: 'bold' }}>Username :</Label>
                                <Input className="form-control" id="username" type="text" name="username" placeholder="Masukkan username..." required
                                    value={data.username}
                                    onChange={handleChanges} />
                            </FormGroup>
                            <FormGroup className='mb-3'>
                                <Label for="password" style={{ fontWeight: 'bold' }}>Password :</Label>
                                <Input className="form-control" id="password" type="text" name="password" placeholder="Masukkan password..." required
                                    onChange={handleChanges} />
                            </FormGroup>
                            {isUpdate && (
                                <>
                                    <FormGroup className='mb-3'>
                                        <Label for="referral_code" style={{ fontWeight: 'bold' }}>Referral Kode :</Label>
                                        <Input className="form-control" id="referral_code" type="text" name="referral_code" placeholder="Masukkan referral kode..." required
                                            value={data.referral_code}
                                            onChange={handleChanges} />
                                    </FormGroup>
                                    <FormGroup className='mb-3'>
                                        <Label for="parent_name" style={{ fontWeight: 'bold' }}>Nama Wali :</Label>
                                        <Input className="form-control" id="parent_name" type="text" name="parent_name" placeholder="Opsional masukkan nama wali..." required
                                            value={data.parent_name}
                                            onChange={handleChanges} />
                                    </FormGroup>
                                    <FormGroup className='mb-3'>
                                        <Label for="parent_phone" style={{ fontWeight: 'bold' }}>No Telpon Wali :</Label>
                                        <Input className="form-control" id="parent_phone" type="tel" name="parent_phone" placeholder="Opsional: 081234567890"
                                            inputMode="numeric"
                                            autoComplete="tel"
                                            minLength={10}
                                            maxLength={13}
                                            pattern="08[0-9]{8,11}"
                                            onKeyDown={handlePhoneKeyDown}
                                            value={data.parent_phone}
                                            onChange={handleChanges} />
                                    </FormGroup>
                                </>
                            )}
                        </Col>
                    </Form>
                </div>
            )}
        </PostCommon>
    );
};

export default UserPostContain;